import { render, staticRenderFns } from "./VideoUsageGuide.vue?vue&type=template&id=6721dda8&scoped=true"
import script from "./VideoUsageGuide.vue?vue&type=script&lang=js"
export * from "./VideoUsageGuide.vue?vue&type=script&lang=js"
import style0 from "./VideoUsageGuide.vue?vue&type=style&index=0&id=6721dda8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6721dda8",
  null
  
)

export default component.exports